var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"columns":_vm.columns,"list":_vm.list}})
}
var staticRenderFns = []

export { render, staticRenderFns }